import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import '../../assets/css/scss/main.css';
import * as icons from 'react-bootstrap-icons';
import RightSideBanner from './RightSideBanner';
import { Link, useNavigate } from 'react-router-dom';
import { REMEMBERED_EMAIL_KEY, SESSION_ENDED_KEY, SetRefreshToken, SetToken, SetUser, pickCurrentSubscription, readApiMessage, readSessionNotice, setRoles, takeReturnPath } from '../../utils/helper/helper';
import { RESEND_VERIFICATION_BUTTON } from '../../utils/helper/emailVerification';
import { CHECKOUT_OUTCOME, clearCheckoutIntent, describePlan, readCheckoutIntent, startCheckout } from '../../utils/helper/checkout';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Alert from 'react-bootstrap/Alert';
import { CreatePymenentUrlFn, GetSubScription, loginUserAPI, PlayerGetSubscribeManager, ResendVerificationEmail } from '../../redux/auth-reducer/auth-service';
import { PRACTICE_MANAGER_EMAIL } from '../../utils/config/config';
import { useDispatch } from 'react-redux';
import { setAuthToeken, setUserInfo } from '../../redux/auth-reducer/auth-reducer';
import { clearNotificationBell } from '../../utils/helper/notifications';
import {
  AUTO_RENEW_OFF_MESSAGE,
  DELETION_CANCELLED_MESSAGE,
  isPendingDeletionRefusal,
  showsAutoRenewNotice,
} from '../../utils/helper/accountDeletion';
import { AccountDeletionNotice } from './AccountDeletionNotice';
import { PASSWORD_REQUIRED, emailError, isValidEmail } from '../../utils/helper/validation';
import { PasswordToggle } from '../../CommonComponent/PasswordToggle';
import { SignUpChoiceModal } from './SignUpChoiceModal';
import { BackButton } from '../../CommonComponent/BackButton';


function Login() {
  const [validated, setValidated] = useState(false);
  let [visible, setVisible] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [smShow, setSmShow] = useState(false);
  // const [playerData, setPlayerData] = useState({
  //   adminAndManager:false,
  //   playerAndMan:false
  // })
  const [user, setUser] = useState({
    email: '',
    password: ''
  })

  const [rememberMe, setRememberMe] = useState(false);
  /** The purchase this visitor arrived with, if any: {planId} | null. */
  const [pendingCheckout, setPendingCheckout] = useState(null);
  const [resumingCheckout, setResumingCheckout] = useState(false);
  // A new sign-up refused until its email is verified: the refusal's message, and the email and
  // password just typed, which "Resend verification email" sends to prove the account is theirs.
  // Held in memory only, for this screen, and dropped at the next sign-in attempt.
  const [unverified, setUnverified] = useState(null);
  const [resending, setResending] = useState(false);
  /**
   * #234: set when Account/Login refused the account because it has a deletion request -
   * {email, deletionDueAt} - and the page shows the deletion notice instead of the form. Kept in
   * state only, never in storage or the URL: a reload or Back goes back to the form.
   */
  const [deletionNotice, setDeletionNotice] = useState(null);
  const { email, password } = user;

  const dispatch = useDispatch()

  const handleLogin = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value })
  }

  const navigate = useNavigate();

  // forceLogout stashes its reason here instead of toasting it, because a toast fired just
  // before a hard navigation never gets painted - which is why the old interceptor's
  // "Session has timeout" message was never actually seen by anyone.
  //
  // #199: an account deletion stashes an informational notice ({type: 'info'}) rather than an
  // error. It stays on screen until dismissed: it is the player's confirmation of when their
  // account will be deleted.
  useEffect(() => {
    const notice = readSessionNotice(sessionStorage.getItem(SESSION_ENDED_KEY));
    if (notice) {
      sessionStorage.removeItem(SESSION_ENDED_KEY);
      if (notice.type === 'info') {
        toast.info(notice.text, { toastId: SESSION_ENDED_KEY, autoClose: false });
      } else {
        toast.error(notice.text, { toastId: SESSION_ENDED_KEY });
      }
    }
  }, []);

  // FE-01: Remember me fills in the email only. It used to store the password as well, AES-encrypted
  // with REACT_APP_API_SECRET - a key CRA compiles into the public bundle, so anyone holding the
  // blob could decrypt it, and it survived every sign-out but one. The password is left to the
  // browser's password manager (autoComplete="current-password" below).
  useEffect(() => {
    const rememberedEmail = localStorage.getItem(REMEMBERED_EMAIL_KEY);
    if (rememberedEmail) {
      setRememberMe(true);
      setUser({ email: rememberedEmail, password: '' });
    }
  }, []);

  // A visitor who chose a plan while signed out is sent here to sign in. Reading the pending
  // purchase on mount only decides what the form says; it is resumed after a successful
  // sign-in, in completeSignIn.
  useEffect(() => {
    setPendingCheckout(readCheckoutIntent());
  }, []);


  /**
   * Stores the session a sign-in issued and takes the user where they belong. The answer is
   * Account/Login's, or since #234 Account/CancelAccountDeletion's, which is the same: a player who
   * cancels their deletion is signed in exactly as by the form.
   *
   * @param {object} data The answer's body, status true.
   * @param {string} [message] The success toast; the server's "Login done successfully." by default.
   * @returns {Promise<boolean>} true when the browser is on its way to Stripe to resume a checkout,
   *   so nothing more should be shown here.
   */
  const completeSignIn = async (data, message = data?.message) => {
    const { token, refreshToken, role, fullName, userId, roleId, email, userImage, isUserInstruction, emailVerified } = data;
    // emailVerified drives the "verify your email" banner (EmailVerificationBanner); an API that
    // predates it sends none, and the banner then asks Account/GetEmailVerification.
    const user = { fullName, userId, roleId, email, userImage, isUserInstruction, emailVerified };

    // #196: nothing from whoever used this browser before belongs on the new session's bell.
    clearNotificationBell();
    // #197: authtoken is a boolean now, so a sign-in that follows a sign-out the SPA never
    // reloaded from would leave it true and the previous account's hub connection open.
    // Dropping it here makes TopNavbar's true build a fresh connection for this account.
    dispatch(setAuthToeken(false));

    // Set tokens and user data
    SetToken(token);
    SetRefreshToken(refreshToken);
    SetUser(user);
    setRoles(role);
    dispatch(setUserInfo(data));

    // #218: a Player's sign-in no longer posts the practice manager a join notice
    // (Announcement/CreateNotification) - it did on every sign-in while that request was
    // Pending. The server writes the practice manager a subscription-request notification once,
    // when the Player registers.

    // #199: where a signed-out visitor was going (Account Settings, the account-deletion link
    // given to Google Play). Taken now, whatever the role, so it never outlives this sign-in;
    // only a Player is sent there, and a pending checkout below still goes first.
    const returnPath = takeReturnPath();

    // FE-01: the email only - never the password. `email` here is the account's own, from the
    // response.
    if (rememberMe) {
      localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
    } else {
      localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    }
    // A checkout interrupted by the sign-in wall is picked up here. Three things were
    // wrong with the previous version: it was not awaited, it erased the stored plan
    // before the call could use it, and its bare `return` skipped every navigate()
    // branch - so any failure left a signed-in player looking at the login form with
    // nothing on screen and the purchase gone.
    const pending = readCheckoutIntent();
    if (pending) {
      if (role === 'Player') {
        setResumingCheckout(true);

        // Back on the Stripe form returns to Home, where the plan was chosen - not to
        // this form, which is only where the checkout happened to resume.
        const result = await startCheckout(() => CreatePymenentUrlFn(pending.planId), {
          returnTo: '/Home',
        });

        if (result.outcome === CHECKOUT_OUTCOME.REDIRECTING) {
          // On the way to Stripe. The intent deliberately stays until /PaymentSuccess or
          // /PaymentCancel clears it, so a redirect that never lands is still recoverable.
          return true;
        }

        setResumingCheckout(false);

        // A refusal is the server's final answer - a plan switch mid-period will be
        // refused again just the same - so the purchase is dropped rather than left to
        // prompt them to retry something that cannot succeed. A transport failure is
        // kept, because that one is worth retrying.
        if (result.outcome === CHECKOUT_OUTCOME.REFUSED) {
          clearCheckoutIntent();
        }

        // apiClient.js has already toasted a transport failure; do not say it twice.
        if (result.outcome === CHECKOUT_OUTCOME.REFUSED || !result.notified) {
          toast.error(result.message);
        }

        // Signed in either way, and landed somewhere the purchase can actually be
        // finished: Account Settings reads any intent still in storage and pre-selects
        // the plan.
        navigate('/Player/Account_settings');
        return false;
      }

      // Not a player: a subscription plan id cannot apply to this account.
      clearCheckoutIntent();
    }

    // Navigation logic
    const userRole = data.role;
    if (userRole === 'Web Admin') {
      toast.success(message);
      navigate('/WebAdmin/Dashboard');
    } else if (userRole === "Manager" || userRole === "Admin") {
      toast.success(message);
      navigate('/SuperAdmin/SuperDashboard');
    } else if (userRole === "Player" && returnPath) {
      toast.success(message);
      navigate(returnPath);
    } else if (userRole === "Player") {
      try {
        const result = await PlayerGetSubscribeManager();
        const managerSubscriptions = result?.data || []; 

        const precticeStatus = managerSubscriptions.some(
          (item) =>
            item?.managerEmailId === PRACTICE_MANAGER_EMAIL &&
            item?.playerEmailId === data.email &&
            item?.status === "Approved"
        );

        if (!precticeStatus) {
          toast.success(message);
          navigate('/Player/AuctionPlayer');
        } else {
          toast.success(message);
          navigate('/Player/Player_dashboard');
        }
      } catch (playerError) {
        console.error("Error fetching player subscriptions:", playerError);
        toast.error("Failed to load player data. Please try again.");
      }
    } else {
      console.log('navigate');
    }
    return false;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // #275: an empty or malformed field is reported on the form and nothing is sent.
    if (!event.currentTarget.checkValidity() || !isValidEmail(email)) {
      setValidated(true);
      return;
    }
    // #275: what the server refuses is said by its toast alone. The fields keep what was typed,
    // so one wrong character is one fix; clearing them used to show "empty field" errors too.
    setValidated(false);
    setIsButtonDisabled(true);
    setUnverified(null);

    try {
      const response = await loginUserAPI(user);

      if (response?.data?.status) {
        await completeSignIn(response.data);
      }
      else if (isPendingDeletionRefusal(response?.data)) {
        // #234: an account with a deletion request - reached only with the right password. The
        // notice replaces the form and offers to cancel; it keeps the email signed in with, never
        // the password, which cancelling asks for again.
        setUser({ email: '', password: '' });
        setDeletionNotice({ email: user.email, deletionDueAt: response.data.deletionDueAt });
      } else if (response?.data?.emailNotVerified) {
        // A new sign-up that has not verified its email: said beside the form, with a way to get a
        // new link, rather than in a toast that goes. The fields keep what was typed (#275).
        setUnverified({ message: response.data.message, email: user.email, password: user.password });
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login.");
    } finally {
      setIsButtonDisabled(false);
    }
  };

  /**
   * #234: the deletion notice cancelled the request, and its answer is a sign-in like the form's.
   * A player whose subscription no longer renews because of the request is told so once they are
   * signed in (AC13) - only when there is a running subscription to turn back on, which the
   * subscription details can only say for a signed-in caller.
   */
  const handleDeletionCancelled = async (data) => {
    const leavingForCheckout = await completeSignIn(data, DELETION_CANCELLED_MESSAGE);

    // Not while the browser is on its way to a resumed checkout: the notice would flash and go.
    if (leavingForCheckout || data.role !== 'Player') return;

    // A courtesy once the player is signed in. Not thrown: the notice would read it as a sign-in
    // that did not finish.
    try {
      const res = await GetSubScription();
      if (showsAutoRenewNotice(pickCurrentSubscription(res?.data?.data || []))) {
        toast.info(AUTO_RENEW_OFF_MESSAGE, { autoClose: false });
      }
    } catch (error) {
      console.error("Error reading the subscription after cancelling a deletion:", error);
    }
  };

  // useEffect(()=>{
  // if(playerData?.adminAndManager){


  // }
  // },[])

  const show = (event) => {
    setVisible(!visible)
  }

  // Emails a new verification link to the account refused above, named by what was typed for it.
  const resendVerification = async () => {
    setResending(true);
    const res = await ResendVerificationEmail(unverified.email, unverified.password);
    setResending(false);

    if (res?.data?.emailVerified === true) {
      // Verified meanwhile (the link, or a password reset): nothing left to send.
      setUnverified(null);
      toast.info(res.data.message);
    } else if (res?.data?.status === true) {
      toast.success(res.data.message);
    } else if (res) {
      toast.error(readApiMessage(res));
    }
  };

  const handleClose = () => setSmShow(false);
  const handleShow = () => setSmShow(true);

  // #234: back to the form from the deletion notice, with the email filled in again. The request
  // stays as it is (AC3).
  const leaveDeletionNotice = () => {
    setUser({ email: deletionNotice?.email ?? '', password: '' });
    setDeletionNotice(null);
  };

  // #234: the deletion notice in place of the form, in the same layout. Back goes to the form, as
  // its own Back to login does.
  if (deletionNotice) {
    return (
      <div className='group-reg'>
        <div className='icon-back'>
          <BackButton onClick={leaveDeletionNotice} />
        </div>
        <div className='item'>
          <div className='inner-item'>
            <div className='form-contnet'>
              <Link to="/Home"> <img src='../image/logo1.png' className='logo-mob-img' /></Link>
              <AccountDeletionNotice
                email={deletionNotice.email}
                deletionDueAt={deletionNotice.deletionDueAt}
                onBack={leaveDeletionNotice}
                onCancelled={handleDeletionCancelled}
              />
            </div>
          </div>
        </div>
        <RightSideBanner />
      </div>
    );
  }


  return (
    <>
      <SignUpChoiceModal show={smShow} onHide={handleClose} />

      <div className='group-reg'>
        <div className='icon-back'>
          <BackButton />
        </div>
        <div className='item'>
          <div className='inner-item'>
            <div className='form-contnet'>
              <div>
                <Link to="/Home"> <img src='../image/logo1.png' className='logo-mob-img' /></Link>

                <h1 className='heading'>Welcome Back</h1>
                <p>Login into your account</p>

                {/* Without this the form gives no sign that a purchase is waiting behind it,
                    which is the "leaves the product on the sign-in form" half of WEB-P1-248. */}
                {pendingCheckout && (
                  <Alert variant="info" className="mt-3">
                    Sign in to finish your {describePlan(pendingCheckout.planId)} subscription
                    - we will take you straight to the payment page.
                  </Alert>
                )}

                {unverified && (
                  <Alert variant="warning" className="mt-3">
                    <p className="mb-2">{unverified.message}</p>
                    <Button size="sm" onClick={resendVerification} disabled={resending}>
                      {RESEND_VERIFICATION_BUTTON}
                    </Button>
                  </Alert>
                )}
              </div>
            </div>
            <Form noValidate validated={validated} className='Login-form' onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="validationCustomFristname">
                  <Form.Label>Email</Form.Label>
                  <InputGroup hasValidation>

                    <icons.Person className='persion-icon' />

                    <Form.Control className='email-input'
                      type="email"
                      name='email'
                      autoComplete="username"
                      value={email}
                      onChange={handleLogin}
                      placeholder="Enter your email"
                      aria-describedby="inputGroupPrepend"
                      required
                      // #274: type="email" alone accepts "a@b".
                      isInvalid={validated && !!email && !isValidEmail(email)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {emailError(email)}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <Form.Group as={Col} md="12" className="text-left " controlId="validationCustomLastname">
                  <Form.Label>Password</Form.Label>
                  <InputGroup className='password-input' hasValidation>

                    <svg width="23px" className='persion-icon lock' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <Form.Control
                      type={visible ? "text" : "password"}
                      name='password'
                      autoComplete="current-password"
                      value={password}
                      onChange={handleLogin}
                      className='email-input password-input-Change'
                      placeholder="Enter your password"
                      aria-describedby="inputGroupPrepend"
                      required
                    />
                    <PasswordToggle visible={visible} onToggle={show} />
                    <Form.Control.Feedback type="invalid">
                      {PASSWORD_REQUIRED}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                {/* #279: one row, one size: the two columns stacked at narrow widths and had
                    different sizes and line heights, so they never shared a baseline. */}
                <Col md="12" className='remember-row'>
                  <label className='rememberInput text-color-la'>
                    <input
                      type="checkbox"
                      className='input-checkbox'
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <span class="checkmark"></span>
                    Remember me
                  </label>
                  <span className='account-para1'><Link to="/ForgotPassword">Forgot password?</Link></span>
                </Col>
                <Col md="12 ">
                  <Button type="submit" disabled={isButtonDisabled || resumingCheckout} className='submit'>Login</Button>
                  {resumingCheckout && <p className="mt-2 mb-0">Taking you to the payment page...</p>}
                </Col>
              </Row>
            </Form>
            <p className='account-para'>Don't have an Account?{' '}
              {/* #278: a button: href="#" added "#" to the URL, and Back then only removed it. */}
              <button type="button" className='link-button' onClick={handleShow}>Register here</button>
            </p>
          </div>
        </div>
        <RightSideBanner />
      </div>
    </>
  )
}

export default Login;
